<template>
  <engagement-layout>
    <template #heading>{{ headerInfo.heading }}</template>
    <!-- <template #info-tooltip>{{ headerInfo.headingIconText }} </template> -->
    <template #sub-heading>{{ headerInfo.subHeading }}</template>

    <template #left-side-bar>
      <mds-list-group with-icon size="medium">
        <mds-list-group-item
          v-for="option in menuCategories"
          :value="option.value"
          :text="option.text"
          :active="option.active"
          :key="option.value"
          @click.native="selectmenu(option)"
        >
        </mds-list-group-item>
      </mds-list-group>
    </template>

    <template #right-side-bar>
      <mds-button-container
        name="client-button-container"
        :class="$style['button-container']"
      >
        <mds-button
          v-for="(button, index) in getButtons"
          :key="index"
          variation="secondary"
          size="small"
          :icon="button.icon"
          :Value="button.value"
          :class="[
            button.value == selectedClientId ? $style['custom-button'] : '',
            $style['custom-buttom-margins'],
          ]"
          @click.native="selectClient(button.value)"
          type="button"
        >
          <span
            v-if="button.icon == undefined"
            style="
              font-size: 11px !important;
              display: inline-block;
              color: black;
              height: 18px !important;
              width: 18px !important;
              line-height: 18px;
              text-align: center;
              border-radius: 50%;
              background-color: rgb(255, 243, 138);
            "
            :style="{ 'background-color': button.backgroundColor }"
          >
            {{ button.logoText }}
          </span>
          {{ button.buttonName }}
        </mds-button>
      </mds-button-container>
      <div
        v-for="(datalist, headerIndex) in filterDataListConfig"
        :key="headerIndex"
      >
        <div :class="$style['datatablelist']" v-if="datalist.isVisible">
          <data-table-list
            :datatablelistconfig="datalist"
            @addNewRow="addNewRow"
            @eventActionHandler="eventActionHandler"
          ></data-table-list>
        </div>
      </div>
    </template>

    <template #footer>
      <page-footer>
        <template #action-button-left>
          <mds-button
            size="large"
            variation="flat"
            @click="onBack"
            icon="caret-left"
          >
            Back
          </mds-button>
        </template>
        <template #action-button-right>
          <mds-button
            type="button"
            variation="secondary"
            @click="cancelButtonClick"
          >
            Cancel
          </mds-button>
          <mds-button
            type="button"
            variation="primary"
            @click="saveButtonClick"
          >
            Save
          </mds-button>
        </template>
      </page-footer>
    </template>
    <!-- end of footer-slot-->
  </engagement-layout>
</template>

<script>
import { EngagementLayout, PageFooter } from "../../component";
import DataTableList from "../custom/data-table-list/DataTableList.vue";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
// import { AdlDataTable } from "@adl-components-ui/data-table";
import { MdsButton } from "@mds/button";

export default {
  components: {
    EngagementLayout,
    MdsListGroup,
    MdsListGroupItem,
    // AdlDataTable,
    PageFooter,
    MdsButton,
    DataTableList,
  },
  async created() {},
  props: {
    headerInfo: {
      type: Object,
    },
    dataListConfig: {
      type: Array,
    },
    selectedButtonId: {
      type: Number,
    },
    menuCategories: {
      type: Array,
    },
  },
  computed: {
    getButtons() {
      if (this.selecteditem == 1) {
        if (this.menuCategories.filter((m) => m.value == this.selecteditem)[0])
          return this.menuCategories.filter(
            (m) => m.value == this.selecteditem
          )[0].configData.buttons;
        else return [];
      }
      return [];
    },
    filterDataListConfig() {
      return this.dataListConfig;
    },
  },

  data() {
    return {
      selecteditem: 1,
      filteredDataListConfig: this.dataListConfig,
      selectedClientId: this.selectedButtonId,
    };
  },
  mounted() {},

  methods: {
    eventActionHandler(methodName, data) {
      this.$emit("eventActionHandler", methodName, data);
    },
    selectClient(clientId) {
      this.selectedClientId = clientId;
      let isVisible = false;
      if (clientId == 0) {
        isVisible = true;
      }
      this.filterDataListConfig.forEach((element) => {
        element.isVisible = isVisible;
      });
      if (clientId != 0)
        this.filterDataListConfig.filter(
          (m) => m.parentGroupId == clientId
        )[0].isVisible = true;
    },
    addNewRow(editData) {
      this.$emit("addNewRow", editData);
    },
    onBack() {
      this.$emit("onBack");
    },
    onNext() {
      this.$router.push({ name: "loan-engagement-tool" });
    },
    selectmenu(data) {
      this.selecteditem = data.value;
      this.$emit("selectfilteredMenu", data);
    },
    cancelButtonClick() {
      this.$emit("cancelInstance", {});
    },
    saveButtonClick() {
      this.$emit("saveInstance", {});
    },
  },
};
</script>

<style lang="scss" module>
@import "@mds/constants";

.button-container {
  display: flex !important;

  .button-container button {
    height: 27px !important;
  }
}

.datatablelist {
  padding-top: $mds-space-3-x;
}

.custom-button {
  background-color: #e0ecf5 !important;
  border: 1px solid #0077cf !important;
  color: #5e5e5e !important;
}

.custom-button:hover {
  color: #5e5e5e !important;
}

.custom-buttom-margins {
  margin-right: $mds-space-2-x;
}
</style>
